import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITopicResource } from "../types";

export type ITopicReworkMutationParameters = { topic: RelationalValue<ITopicResource> };

export const topicReworkMutation: IApiMutationFunction<ITopicReworkMutationParameters> = ({ topic }) => ({
    method: "PUT",
    url: `/topics/${mapRelationalValue(topic)}/rework`,
    data: {},
});

export const useTopicReworkMutation = createApiMutationHook<ITopicReworkMutationParameters, ITopicResource>(
    topicReworkMutation,
);
